
import { defineComponent } from '@vue/composition-api';
import { PreviewEvent, LiveEventsEvent } from '../../../../types/sport';
import SportIcons from './SportIcons.vue';
import {
  formatSecondsToTimeWithMinutes,
  formatTime
} from '@/composables/utils';

export default defineComponent({
  name: 'EventItem',
  components: {
    SportIcons
  },
  props: {
    event: {
      type: Object as () => PreviewEvent | LiveEventsEvent,
      required: true
    },
    sportId: {
      type: String,
      required: true
    },
    categoryId: {
      type: String,
      required: true
    },
    tournamentId: {
      type: String,
      required: true
    },
    eventId: {
      type: String,
      required: true
    },
    baseUrl: {
      type: String,
      default: '/sport'
    },
    currentLanguage: {
      type: String,
      default: ''
    }
  },
  computed: {
    isLiveEvent(): boolean {
      return !!(this.event as any).livescore;
    },
    eventPath(): string {
      return `${this.baseUrl}/${this.sportId}/category/${this.categoryId}/tournament/${this.tournamentId}/event/${this.eventId}`;
    },
    language(): string {
      return (
        this.currentLanguage ||
        (this.$store.getters['settings/getLanguage'] as string) ||
        'en'
      );
    }
  },
  methods: {
    formatSecondsToTimeWithMinutes,
    formatTime,
    getCurrentPeriod(period: any[]): string {
      if (!Array.isArray(period) || period.length === 0) {
        return '';
      }
      const find = period.find((p: any) => p.lang === this.language);
      if (find) {
        return find.text || '';
      }
      const findEn = period.find((p: any) => p.lang === 'en');
      if (findEn) {
        return findEn.text || '';
      }
      return '';
    }
  }
});
